import {
  ComponentTypeFactory,
  FieldTypeFactory,
} from '@sentecacommerce-theme/base'
import { BrochureProps } from './brochure.props'

export const BrochureType = ComponentTypeFactory.create<BrochureProps>(
  'Brochure',
  {
    pdf: FieldTypeFactory.text(),
    title: FieldTypeFactory.text(),
    errorMessage: FieldTypeFactory.text(),
    pageHeight: FieldTypeFactory.number(),
    pageWidth: FieldTypeFactory.number(),
  }
)
